import { QueryClient } from "@tanstack/react-query";
import { redirect } from "react-router-dom";
import { getCabinetQueryOptions } from "@/entities/cabinet/api/getCabinetQueryOptions";
import { CabinetStatuses } from "@/pages/Cabinet/types";

export const cabinetPaymentLoader = (queryClient: QueryClient) => async () => {
  const token = localStorage.getItem("token");
  if (!token) {
    return redirect("/auth", { status: 301 });
  }

  const cabinetResponse = await queryClient.fetchQuery(
    getCabinetQueryOptions(token),
  );

  const agreementData = cabinetResponse?.data?.agreement;
  const componentData = cabinetResponse?.data;
  const loanData = componentData?.data;
  const paymentsSchedule = loanData?.schedule;

  const isPaymentRefinance =
    cabinetResponse?.component === CabinetStatuses.prolongation;
  const isSignAgreement =
    cabinetResponse?.component === CabinetStatuses.sign &&
    !agreementData?.hasParent;
  const isSignRefinance =
    cabinetResponse?.component === CabinetStatuses.sign &&
    agreementData?.hasParent;

  const showDealStatus =
    agreementData &&
    !isSignAgreement &&
    !isSignRefinance &&
    !isPaymentRefinance;

  const showPaymentsSchedule =
    (componentData?.status === 7 || componentData?.agreement?.status === 7) &&
    loanData &&
    paymentsSchedule;

  const showDefermentPayment = componentData?.status === 13;

  const shouldRedirect =
    !showDealStatus && !showPaymentsSchedule && !showDefermentPayment;

  if (shouldRedirect) {
    return redirect("/cabinet", { status: 301 });
  }

  return cabinetResponse;
};
